import styled from "styled-components";
import { Container } from "../../theme/styles";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { Form } from "./components/Form";
import bannerSrc from '../../assets/images/banner-home.jpeg';
import abstractSrc from '../../assets/images/abstract.png';

function LDA() {
  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} title="IBDAutoral" />
      <Container>
        <Content>
          <TextContent>
            <Title>LDA Comentada</Title>
            <Text>
              Lorem ipsum dolor sit amet, consectur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua
            </Text>
            <Text>
              Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.
            </Text>
            <Image src={abstractSrc} />
          </TextContent>
          <Form />
        </Content>
      </Container>
      <Footer />
    </>
  );
}

export default LDA

const Content = styled.div`
  display: flex;
  padding: 64px 0 0;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
    padding: 0;
    margin-top: -32px;
    z-index: 1;
    position: relative;
  }
`;

const TextContent = styled.div`
  flex: 10;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    text-align: center;
  }
`;

const Title = styled.span`
  display: inline-block;
  font-size: 64px;
  color: ${({ theme }) => theme.colors.blue.dark};
  background-color: ${({ theme }) => theme.colors.orange.medium};
  padding: 0 20px;
  margin-bottom: 24px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 32px;
    padding: 12px 32px;
  }
`;

const Text = styled.p`
  font-size: 30px;
  padding-left: 20px;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.colors.gray.darker};
  text-align: justify;
  text-justify: inter-word;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 18px;
    padding: 0 12px;
    margin-bottom: 16px;
  }
`;

const Image = styled.img`
  max-width: 330px;
  height: auto;
  display: block;
  padding-bottom: 10px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;